import {
  Button,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import PropTypes from 'prop-types';
import PropsType from 'props-type';

const propTypes = {
  allowSignatureTypesText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  participantName: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

const defaultProps = {
  isOpen: false,
  onCancel() {},
  onConfirm() {},
};

type SelectAllowSignatureTypeConfirmModalProps = PropsType<typeof propTypes, typeof defaultProps>;

function SelectAllowSignatureTypeConfirmModal({
  allowSignatureTypesText,
  isOpen,
  participantName,
  onCancel,
  onConfirm,
}: SelectAllowSignatureTypeConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} maxWidth="xxs" onClose={onCancel}>
      <ModalTitle>사인/도장 이용 안내</ModalTitle>
      <ModalContent>
        <Text as="p" textAlign="center">
          서명자당 한 종류만 설정이 가능해요.
          <br />
          {participantName}님의 서명 방식을
          <br />
          모두 [{allowSignatureTypesText}]으로 변경하시겠어요?
        </Text>
      </ModalContent>
      <ModalFooter>
        <Button mr={3} variant="basic" onClick={onCancel}>
          취소
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          변경하기
        </Button>
      </ModalFooter>
    </Modal>
  );
}

SelectAllowSignatureTypeConfirmModal.propTypes = propTypes;
SelectAllowSignatureTypeConfirmModal.defaultProps = defaultProps;

export default SelectAllowSignatureTypeConfirmModal;
